import { ReactElement } from 'react';

import { IProps } from './types';
import * as S from './styles';

export function SliceFormEmbded({ slice: { primary } }: IProps): ReactElement {
  return (
    <S.Wrapper id="slice-form-embded" className="slice-item slice-form-embded">
      <iframe title="typeform-embed" src={(primary?.embded_link as any)?.url} />
    </S.Wrapper>
  );
}

SliceFormEmbded.componentName = 'formembded';
